module.exports = __webpack_public_path__ + "static/img/pcmt_xiamo_gd.26e88ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pcmt_xiamo_gd.jpg
// module id = aQEI
// module chunks = 1